import config from '@/config/index';

/**
 * 获取所有一带一路的机构（ 一带一路国家的机构）
 * @param district     地区
 * @param page         当前第几页
 * @param limit        限制多少页
 * @param request
 * @GetMapping("/orglistbynation")
 */
function orglistbynation() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/orglistbynation`;
}

/**
 * 获取一带一路专题数据 ( 产品 服务 专家) 后台用
 *
 * @GetMapping("/recommentsilkroadlist")
 */
function getRecommentSikeRoad() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/recommentsilkroadlist`;
}

export {
  orglistbynation,
  getRecommentSikeRoad
}
